module.exports = __webpack_public_path__ + "static/media/background-check-shield.3820db67.svg";